import { useContext, useMemo } from 'react';
import { storesContext } from 'stores';

const useProgress = (catalogEntryCode: string) => {
  const { progressStore } = useContext(storesContext);

  const [progress, progressPercentage] = useMemo(() => {
    if (!catalogEntryCode) {
      return [0, 0];
    }

    const progressEntry = progressStore.progressByCourse.find((c) => {
      const { course_code: courseCode } = c || {};
      return courseCode === catalogEntryCode;
    });

    if (!progressEntry) {
      return [0, 0];
    }

    const { total_progress: totalProgress } = progressEntry;

    return [totalProgress, Math.round(totalProgress * 100)];
  }, [progressStore.progressByCourse, catalogEntryCode]);

  return { hasProgress: progress > 0, progress, progressPercentage };
};

export default useProgress;
